import React, { Component } from 'react';

import './styles.css';

class ImageHover extends Component {
  constructor(props){
    super(props);
    this.state = {
      hiddenHeight: 0,
      opened: false,
    }
  }

  componentWillMount(){
    let windowHeight = window.innerHeight;
    let widnowWidth = window.innerWidth;
    window.addEventListener("resize", (event) => {
      if(this.imageRef){
        this.setState({
          hiddenHeight: this.imageRef.offsetHeight,
        });
      }
    });
    window.addEventListener('scroll', (event) => {
      if(widnowWidth <= 640){
        if((windowHeight/2) > (this.containerRef.getBoundingClientRect().top)){
          if(this.containerRef.getBoundingClientRect().top > 0){
            this.openHover();
          }else{
            this.hideHover();
          }
        }else{
          this.hideHover();
        }
      }
    });
  }

  componentDidMount(){
    setTimeout(() => {
      if(this.imageRef){
        this.setState({
          hiddenHeight: this.imageRef.offsetHeight,
        });
      }
    }, 300);
  }

  openHover(event){
    this.setState({opened: true});
  }
  hideHover(event){
    this.setState({opened: false});
  }

  render(){
    let classes = ['image-container'];
    let hoverClasses = ['hovered'];
    if(this.props.top) {
      classes.push('image-top');
      hoverClasses.push('hover-top')
    }
    if(this.props.bottom) {
      classes.push('image-bottom');
      hoverClasses.push('hover-bottom')
    }
    if(this.state.opened){
      hoverClasses.push('opened')
    }
    if(!this.props.bottom && !this.props.top){
      hoverClasses.push('hover-top')
    }
    return (
      <div className={classes.join(' ')} ref={(ref) => {this.containerRef = ref}}>
        {this.props.bottom && (
          this.props.children
        )}
        <img onMouseEnter={this.openHover.bind(this)} onMouseLeave={this.hideHover.bind(this)} ref={(imageRef) => {this.imageRef = imageRef}} src={this.props.image} alt={this.props.image} />
        {this.props.top && (
          this.props.children
        )}
        {this.props.top && (
          <div onMouseEnter={this.openHover.bind(this)} onMouseLeave={this.hideHover.bind(this)} className={hoverClasses.join(' ')} /*style={{height: `${this.state.hiddenHeight}px`}}*/>
            {this.props.hoverComponent}
          </div>
        )}
        {this.props.bottom && (
          <div onMouseEnter={this.openHover.bind(this)} onMouseLeave={this.hideHover.bind(this)} className={hoverClasses.join(' ')} /*style={{height: `${this.state.hiddenHeight}px`}}*/>
            {this.props.hoverComponent}
          </div>
        )}
        {!this.props.bottom && !this.props.top && (
          <div onMouseEnter={this.openHover.bind(this)} onMouseLeave={this.hideHover.bind(this)} className={hoverClasses.join(' ')} /*style={{height: `${this.state.hiddenHeight}px`}}*/>
            {this.props.hoverComponent}
          </div>
        )}
      </div>
    );
  }
}

export default ImageHover;



// WEBPACK FOOTER //
// ./src/components/ImageHover/ImageHover.js